import { createSlice } from "@reduxjs/toolkit";
import {
  getUser,
  updateUser,
  deleteUser,
  getAtcUsers,
} from "../apiActions/userActions";
import { notification } from "antd";

export type User = {
  id: string;
  created_at: string;
  username: string;
  email: string;
  permissions: string[];
  student_id: string;
  atc: {
    name: string;
    id: string;
    created_at: string;
  };
  banned: boolean;
  hidden: boolean;
};

interface UserState {
  loading: {
    get: boolean;
    create: boolean;
    update: boolean;
    delete: boolean;
  };
  deleteLoading: boolean;
  error: null | string;
  users: User[];
  usersAtc: User[];
  modal: boolean;
}

const initialState: UserState = {
  users: [],
  usersAtc: [],
  error: null,
  loading: {
    get: false,
    update: false,
    delete: false,
    create: false,
  },
  deleteLoading: false,
  modal: false,
};

const userSlice = createSlice({
  name: "request",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state: UserState) => {
        state.loading.get = true;
        state.error = null;
      })
      .addCase(getUser.fulfilled, (state: UserState, action) => {
        state.loading.get = false;
        state.error = null;
        state.users = action.payload;
        state.modal = false;
      })
      .addCase(getUser.rejected, (state: UserState, action) => {
        state.loading.get = false;
      })
      .addCase(getAtcUsers.pending, (state: UserState) => {
        state.loading.get = true;
        state.error = null;
      })
      .addCase(getAtcUsers.fulfilled, (state: UserState, action) => {
        state.loading.get = false;
        state.error = null;
        state.usersAtc = action.payload;
        state.modal = false;
      })
      .addCase(getAtcUsers.rejected, (state: UserState, action) => {
        state.loading.get = false;
      })
      .addCase(updateUser.pending, (state: UserState) => {
        state.loading.get = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state: UserState, action) => {
        state.loading.get = false;
        state.error = null;
        state.modal = false;
      })
      .addCase(updateUser.rejected, (state: UserState, action) => {
        state.loading.get = false;
        notification.error(action.payload as any);
      })
      .addCase(deleteUser.pending, (state: UserState) => {
        state.loading.get = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state: UserState, action) => {
        state.loading.get = false;
        state.error = null;
        state.modal = false;
      })
      .addCase(deleteUser.rejected, (state: UserState, action) => {
        state.loading.get = false;
        notification.error(action.payload as any);
      });
  },
});

// export const {} = userSlice.actions;
export default userSlice.reducer;
